import { Injectable } from '@angular/core';
import { OrderTypeEnum } from '@core/enums';
import { ModalController } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';
import { StoresComponent } from '@/features/storesView/stores.component';

export type ServiceType = OrderTypeEnum;

@Injectable({
  providedIn: 'root',
})
export class SwitchService {
  private serviceTypeSubject = new BehaviorSubject<ServiceType>(OrderTypeEnum.Pickup);
  private isModalOpen = false;

  constructor(
    private modalCtrl: ModalController
  ) {}

  serviceType$ = this.serviceTypeSubject.asObservable();

  get currentServiceType(): ServiceType {
    return this.serviceTypeSubject.value;
  }

  setServiceType(type: ServiceType): void {
    this.serviceTypeSubject.next(type);
  }

  async openDeliveryModal(): Promise<void> {
    if (this.isModalOpen) return;
    
    this.isModalOpen = true;
    try {
      const modal = await this.modalCtrl.create({
        component: StoresComponent,
        cssClass: 'delivery-modal-class',
        componentProps: { showMap: false, IsModal: true },
        backdropDismiss: false
      });

      const dismissal = modal.onDidDismiss();
      await modal.present();
      dismissal.then(() => {
        this.isModalOpen = false;
      });
    } catch (error) {
      this.isModalOpen = false;
      console.error('Error opening delivery modal:', error);
    }
  }
}
